import { Domain, DomainManifest } from "@swivl-mono/types";

/**
 * Registry of Domain manifests the AI Studio exposes.
 *
 * **Code-driven only** — Chuck 2026-04-24: adding a new Domain is always a code
 * change (new enum value in `libs/types/src/Domain/Domain.Data.ts` + a new
 * manifest entry below + a new `apps/bot/src/Domains/<Name>/` folder).
 *
 * The mirror registry in the bot lives at `apps/bot/src/Domains/<Name>/Domain.ts`.
 * Studio duplicates the lightweight UI-visible manifest here so the Studio build
 * doesn't have to import apps/bot code (cross-app imports not allowed).
 *
 * See docs/snowy/plans/2026-04-24-domain-architecture-implementation-plan.md
 */
export const DOMAIN_MANIFESTS: DomainManifest[] = [
  {
    id: Domain.Storage,
    displayName: "Storage",
    description: "Customer-facing self-storage bot: sales, service, access, billing.",
    aiStudioPages: ["prompts", "testing", "evals", "conversations", "user-stories"]
  }
  // The dormant Coaching *domain* skeleton (offline transcript rubric-scoring,
  // never built) was deleted with ENG-2957 — "Coaching" now names the live
  // Contact Center coaching system (engine in apps/bot/src/Coaching/).
];
